<template>
    <el-container direction="vertical" v-loading="loading">
        <el-row>
            <el-col :span="14" justify="start" class="pr10">
                <el-form :model="task" label-position="top">
                    <el-row class="mb10" v-if="!isNew">
                        <el-col :span="5" class="form-label">
                            Дата создания
                        </el-col>
                        <el-col :span="6">
                            <div>
                                {{ task.created_at }}
                            </div>
                        </el-col>
                        <el-col :span="6" class="form-label">
                            Сделка или лид
                        </el-col>
                        <el-col :span="7">
                            <template v-if="issetRelatedEntity">
                                <div class="link" @click="goRelatedEntity()">
                                    {{ task.related_entity_id }}
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="4" class="form-label">
                            Заголовок
                        </el-col>
                        <el-col :span="20">
                            <div :class="{ 'error-input': errors.title }">
                                <el-input v-model="task.title" size="mini" autocomplete="off" />
                                <div class="error" v-if="errors.title">
                                    {{ errors.title[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10" v-if="!isNew">
                        <el-col :span="4" class="form-label">
                            Статус
                        </el-col>
                        <el-col :span="20" :class="{ 'error-input': errors.status_id }">
                            <el-select v-model="task.status_id" placeholder="" size="mini">
                                <el-option
                                    v-for="taskStatus in taskStatuses"
                                    :key="taskStatus.id"
                                    :label="taskStatus.name"
                                    :value="taskStatus.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.status_id">
                                {{ errors.status_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="2" class="form-label">
                            Срок
                        </el-col>
                        <el-col :span="6" :class="{ 'error-input': errors.planned }">
                            <template>
                                <div class="block date-picker">
                                    <el-date-picker
                                        v-model="task.planned_date"
                                        type="date"
                                        placeholder="дата"
                                        clearable
                                        format="dd.MM.yyyy"
                                        value-format="dd.MM.yyyy"
                                        size="mini"
                                        class="w100"
                                        :picker-options="pickerOptions"
                                    />
                                </div>
                            </template>
                            <div class="error" v-if="errors.planned">
                                {{ errors.planned[0] }}
                            </div>
                        </el-col>
                        <el-col :span="3" class="form-label pl10">
                            Время
                        </el-col>
                        <el-col :span="4">
                            <el-select v-model="task.planned_time" placeholder="" size="mini">
                                <el-option
                                    v-for="item in defaultTimeList"
                                    :key="item"
                                    :value="item"
                                />
                            </el-select>
                            <div class="form-error" v-if="errors.planned" v-text="errors.planned[0]"></div>
                        </el-col>
                        <el-col :span="4" class="form-label pl5">
                            Приоритет
                        </el-col>
                        <el-col :span="5">
                            <el-select v-model="task.priority" placeholder="" size="mini">
                                <el-option
                                    v-for="taskPriority in taskPriorityList"
                                    :key="taskPriority.id"
                                    :label="taskPriority.name"
                                    :value="taskPriority.id"
                                />
                            </el-select>
                            <div class="form-error" v-if="errors.priority" v-text="errors.priority[0]"></div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10" v-if="!isNew">
                        <el-col :span="5" class="form-label">
                            Постановщик
                        </el-col>
                        <el-col :span="19">
                            <div>
                                {{ createdUserName }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="5" class="form-label">
                            Исполнитель
                        </el-col>
                        <el-col :span="19" :class="{ 'error-input': errors.assigned_user_id }">
                            <el-select
                                v-model="task.assigned_user_id"
                                autocomplete
                                filterable
                                clearable
                                size="mini"
                                placeholder="Введите имя исполнителя"
                            >
                                <el-option
                                    v-for="employer in employerOptions"
                                    :key="employer.id"
                                    :label="employer.name"
                                    :value="employer.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.assigned_user_id">
                                {{ errors.assigned_user_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10" v-if="!isNew">
                        <el-col :span="6" class="form-label">
                            Дата завершения
                        </el-col>
                        <el-col :span="18">
                            <div>
                                {{ task.finished }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="3" class="form-label">
                            Файлы
                        </el-col>
                        <el-col :span="21">
                            <el-upload
                                class="task-card-upload"
                                action=""
                                :auto-upload="false"
                                :on-change="handleChange"
                                :on-exceed="handleExceed"
                                :limit="10"
                                :file-list="uploadFileList"
                                :show-file-list="false"
                                multiple
                                accept="*"
                            >
                                <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                            </el-upload>
                            <div class="task-card-files">
                                <el-tag
                                    v-for="file in uploadFileList"
                                    :key="file.name"
                                    closable
                                    type=""
                                    @close="handleClose(file)"
                                    class="pointer"
                                    size="mini"
                                    :disable-transitions="true"
                                >
                                    {{ file.name }}
                                </el-tag>
                                <div class="field-error" v-if="errors.place_photo" v-text="errors.place_photo[0]"></div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="5" class="form-label">
                            Новый<br>комментарий
                        </el-col>
                        <el-col :span="19" :class="{ 'error-input': errors.new_comment }">
                            <el-input
                                size="mini"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder=""
                                v-model="task.new_comment"
                            />
                            <div class="error" v-if="errors.new_comment">
                                {{ errors.new_comment[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="text-center pt16">
                        <el-col>
                            <el-button type="warning" @click="save">
                                {{ saveBtnText }}
                            </el-button>
                            <el-button type="info" @click="close">
                                Отменить
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="10">
                <div class="task-comments-title">
                    Комментарии
                </div>
                <scrolly class="task-comments fnt-15" v-if="task.commentaries">
                    <scrolly-viewport>
                        <div
                            v-for="commentDate in Object.keys(task.commentaries)"
                            :key="commentDate"
                            class="day"
                        >
                            <div class="title-date">
                                {{ getCommentDate(commentDate) }}
                            </div>
                            <div
                                v-for="comment in task.commentaries[commentDate]"
                                :key="comment.id"
                            >
                                <div class="comment">
                                    <span class="name">
                                        {{ comment.employer ? comment.employer.full_name : 'неизвестен' }}
                                    </span>
                                    <span class="time">
                                        {{ comment.created_time }}
                                    </span>
                                </div>
                                <div class="text" v-html="prepareText(comment.text)">
                                </div>
                            </div>
                        </div>
                    </scrolly-viewport>
                    <scrolly-bar axis="y" />
                </scrolly>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import CardEdit from '@/views/tasks/CardEdit';
import { eventBus } from '@/common/eventBus';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';

export default {
    name: 'TaskCardEdit',
    data() {
        return {
        };
    },
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        entityId: {
            type: [String, Number],
            default: 0
        },
        entityType: {
            type: String,
            default: 'lead'
        }
    },
    extends: CardEdit,
    components: {
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },
    methods: {
        close() {
            this.$emit('closePopUp', false);
        },
        actionAfterSave(data) {
            this.$message({
                showClose: true,
                message: 'Задача сохранена',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
            eventBus.$emit('task-updated', true);
        },
        actionAfterSaveError(data) {
            this.$message({
                showClose: true,
                message: 'Задача не сохранена',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        }
    }
};
</script>
